/**
 * Typed client for /shareholder-portal/system-map/* — backs the investor
 * System Map screen. Serves the SHAREHOLDER-SAFE (redacted, de-risked) clone
 * of the NUREV system map. Shareholder-gated server-side; these endpoints
 * return raw bodies (not the {success,data} envelope), so no unwrap().
 */
import { client } from './client';

export interface BrainPage {
  path: string; // repo-relative, e.g. "Systems/nurev-api.md"
  title: string; // basename without .md
  folder: string; // top-level folder, '' for root
}

export interface BrainPageContent {
  path: string;
  markdown: string;
}

export interface BrainGraphNode {
  id: string; // page path
  title: string;
  folder: string;
  degree: number;
}
export interface BrainGraphLink {
  source: string;
  target: string;
}
export interface BrainGraphData {
  nodes: BrainGraphNode[];
  links: BrainGraphLink[];
}

const BASE = '/shareholder-portal/system-map';

export async function fetchBrainTree(): Promise<BrainPage[]> {
  const r = await client.get<{ pages: BrainPage[] }>(`${BASE}/tree`);
  return r.data.pages;
}

export async function fetchBrainPage(path: string): Promise<BrainPageContent> {
  const r = await client.get<BrainPageContent>(`${BASE}/page`, {
    params: { path }
  });
  return r.data;
}

export async function fetchBrainGraph(): Promise<BrainGraphData> {
  const r = await client.get<BrainGraphData>(`${BASE}/graph`);
  return r.data;
}
